/**
 * Loads the Jitsi Meet external API script from a backend-specific URL.
 * The URL is provided per-call so the same loader works for both the
 * 8x8 JaaS backend (https://8x8.vc/{appId}/external_api.js — the appId
 * path segment is REQUIRED by JaaS) and the self-hosted VPS
 * (https://jitsi.attps.cloud/external_api.js).
 */

let pendingLoad = null
let loadedFrom = null

export function loadJitsiExternalApi(scriptUrl) {
  if (typeof window === 'undefined') return Promise.resolve()
  if (window.JitsiMeetExternalAPI && loadedFrom === scriptUrl) {
    return Promise.resolve()
  }
  if (pendingLoad && loadedFrom === scriptUrl) {
    return pendingLoad
  }

  loadedFrom = scriptUrl
  pendingLoad = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = scriptUrl
    script.async = true
    script.onload = () => resolve()
    script.onerror = error =>
      reject(new Error(`Failed to load Jitsi API from ${scriptUrl}: ${error}`))
    document.body.appendChild(script)
  })
  return pendingLoad
}
